<template>
  <div class="code-diff-container">
    <template v-if="isHasChange">
      <div class="text-center" v-show="isLoading">
        <p class="mb-0"><a-icon type="sync" spin /> {{ loadingStatus }}...</p>
      </div>
      <iframe id="codeDiffIframe" v-show="!isLoading" v-on:load="iframeLoaded" style="border: none; margin: 0; padding: 0; width: 100%; height: 100%;"></iframe>
    </template>
    <template v-if="!isHasChange">
      <h5>
        There is no change between the 2 versions.
      </h5>
      <div class="not-change">
        <pre>
          {{ oldString }}
        </pre>
      </div>
    </template>
  </div>
</template>

<script>
  import { createPatch } from 'diff';
  import { parse, html as diffHtml } from 'diff2html';
  //import 'diff2html/bundles/css/diff2html.min.css';
  //import {Diff2HtmlUI} from "diff2html/lib/ui/js/diff2html-ui";

  export default {
    name: 'CodeDiff',
    props: {
      oldString: {
        type: String,
        default: ''
      },
      newString: {
        type: String,
        default: ''
      },
      context: {
        type: Number,
        default: ''
      },
      outputFormat: {
        type: String,
        default: ''
      },
      beautify: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isLoading: true,
        isHasChange: true,
        diffString: '',
        configuration: {
          renderNothingWhenEmpty: false,
          outputFormat: '',
          drawFileList: false,
          matching: 'none',
          maxLineSizeInBlockForComparison: 10000
        },
        loadingStatus: 'Preparing',
      };
    },
    mounted: function () {
      // this.configuration.outputFormat = this.outputFormat || 'line-by-line';
      this.configuration.outputFormat = this.outputFormat;

      // this.configuration.outputFormat = this.outputFormatLocalStorage ? this.outputFormat : 'line-by-line';

      this.$nextTick(function () {
        console.time("differ");
        const targetElement = document.getElementById('codeDiffViewer');
        console.timeLog("differ", "Start Config");        
        const configuration = {...this.configuration};
        /*console.timeLog("differ", "Start Diff");
        //let diffString = this.diff_createPatch(this.oldString, this.newString);
        const args = ['', this.oldString, this.newString, '', '', {context: this.context}];
        let diffString = createPatch(...args);
        this.diffString = diffString;*/

        // https://blog.pixelastic.com/2017/09/12/sending-data-to-an-iframe-with-vue-js/
        console.timeLog("differ", "Start UI Init");

        const fakeIframeShadow = document.getElementById("codeDiffIframe");
        fakeIframeShadow.src = "/codediff.html";

      });
    },
    computed: {
      html() {
        //return this.createdHtml(this.oldString, this.newString, this.context, this.outputFormat);
      }
    },
    watch: {
      outputFormat: function (val) {
        this.configuration.outputFormat = val;
        this.iframeLoaded();
      },

      context: function (val) {
        this.context = val;
        this.createdHtml(this.oldString, this.newString, this.context, this.configuration.outputFormat);
        this.iframeLoaded();
      },
    },
    methods: {
      iframeStatusChanged(status) {
        console.log("IframeStatusChanged", status);
        this.loadingStatus = status;
        if (status == "Completed") {
          this.isLoading = false;
        }
      },
      iframeLoaded() {
        this.isLoading = true;
        console.log("Iframe Loaded!");
        let parentHeight = document.getElementById('codeDiffIframe').parentElement.parentElement.parentElement.offsetHeight;
        let parentTop = document.getElementById('codeDiffIframe').parentElement.parentElement.parentElement.offsetTop;
        let myTop = document.getElementById('codeDiffIframe').parentElement.parentElement.offsetTop;
        document.getElementById('codeDiffIframe').style.height =
            (parentHeight - (myTop - parentTop) - 30) + "px";

        document.getElementById('codeDiffIframe').contentWindow.updateStatus = this.iframeStatusChanged;
        document.getElementById('codeDiffIframe').contentWindow.renderDiff(this.oldString, this.newString, {context: this.context}, this.configuration, this.beautify);
      },
      createdHtml(oldString, newString, context, outputFormat) {
        const args = ['', oldString, newString, '', '', { context: context }];
        console.log("Start create patch");
        const dd = createPatch(...args);
        //const dd = this.diff_createPatch(oldString, newString);
        console.log("End create patch");
        // This parsing is just to determine if there is a change
        const outStr = parse(dd, { ...this.configuration, outputFormat });
        //console.log(outStr);

        this.isHasChange = outStr && outStr[0] && outStr[0].blocks && outStr[0].blocks.length;

        // This part actually displays the output
        const html = diffHtml(outStr, { ...this.configuration, outputFormat });
        return html;
      },
      diff_createPatch(oldString, newString) {
        // Format the diff match patch result to be usable with Diff2Html
        const dmp = new DiffMatchPatch();
        dmp.Patch_Margin = 1000;

        const diff = this.diff_lineMode(oldString, newString, dmp);
        const patch_list = dmp.patch_make(oldString, newString, diff);
        const patch_text = dmp.patch_toText(patch_list);

        let lines = patch_text.split("\n");
        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          const lineType = line.substr(0, 1);
          if (lineType === ' ' || lineType === '+' || lineType === '-') {
            let lineContent = line.substr(1);
            lineContent = decodeURIComponent(lineContent);
            lineContent = lineContent.replaceAll("\n", "\n"+lineType);
            line = lineType + lineContent;
          }
          lines[i] = line;
        }
        const modified_patch_text = lines.join("\n");

        const header = "--- \t\n+++ \t\n";

        return header + modified_patch_text;
      },
      diff_lineMode(text1, text2, dmp) {
        // https://github.com/google/diff-match-patch/wiki/Line-or-Word-Diffs
        // https://github.com/google/diff-match-patch/issues/62
        const a = dmp.diff_linesToChars_(text1, text2);
        const lineText1 = a.chars1;
        const lineText2 = a.chars2;
        const lineArray = a.lineArray;
        const diffs = dmp.diff_main(lineText1, lineText2, false);
        dmp.diff_charsToLines_(diffs, lineArray);
        return diffs;
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .d2h-file-side-diff .d2h-code-wrapper .d2h-diff-table {
      margin-top: 0;
      position: relative;
    }
  }
  .code-diff-container .not-change {
    overflow: auto;
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    pre {
      overflow: visible;
    }
  }
</style>
